import axios from '@/utils/miniAxios'
/**
 * 查询配置列表
 *
 */
export function signInlist(params) {
    return new Promise((resolve, reject) => {
        axios.get('/api/activity/sign/config/list', { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 查询已经签到了多少天了
export function queryTodaySignInDay() {
    return new Promise((resolve, reject) => {
        axios.get('/api/activity/sign/queryTodaySignInDay')
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 签到
export function querySignIn() {
    return new Promise((resolve, reject) => {
        axios.get('/api/activity/sign/sign')
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
